import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {FeatureFlagsService} from '../services/feature-flags.service';

export const featureUnavailableGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const featureFlags = inject(FeatureFlagsService);
  const featureKey = typeof route.data?.['featureKey'] === 'string' ? route.data['featureKey'] : '';

  if (!featureKey) {
    return true;
  }

  return featureFlags.ensureLoaded().pipe(
    map(() => {
      if (featureFlags.isAccessible(featureKey)) {
        return true;
      }
      if (featureFlags.isVisible(featureKey)) {
        return router.createUrlTree(['/coming-soon']);
      }
      return router.createUrlTree(['/unavailable']);
    })
  );
};

